<script setup lang="ts">
  import { useMeterReadModalState } from "@/lib/meterReadFrequencyModal"
  import Button from "@/components/ui/button/Button.vue"
  import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogIllustration,
    DialogTitle,
  } from "@/components/ui/dialog"

  import confirmation from "@/assets/illustrations/confirmation.svg"

  const { state } = useMeterReadModalState()
  const handleClose = () => {
    state.show = false
  }
</script>

<template>
  <Dialog :open="state.show" @update:open="handleClose">
    <DialogContent class="text-center">
      <template #illustration>
        <DialogIllustration :src="confirmation" alt="Confirmation" />
      </template>
      <DialogHeader>
        <DialogTitle class="text-center" data-testid="dialog-title">
          You've successfully changed your meter reading frequency to
          <span>{{ state.readFrequency }}</span>
        </DialogTitle>

        <p class="text-center">
          Please note that any changes to your read frequency will take effect
          from midnight.
        </p>
      </DialogHeader>

      <DialogFooter class="flex sm:justify-center">
        <DialogClose as-child>
          <Button variant="primary">Close</Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
